module.exports = __webpack_public_path__ + "img/09-JS-testimonials.d6de2ee1.svg";